import React from 'react';
import { SectionContainer } from '../../styles';
import { Box, Title, VerticalBox } from '../../../../components';
import { AboutUsTeam as TypeAboutUsTeam } from '../../../../services/about-us/fetchAboutUsPageContent';
import { COLORS, device, FONTS } from '../../../../constants';
import styled from 'styled-components';
import { AboutUsTeamItem } from './AboutUsTeamItem';
import { MotionText, MotionYOffsetBlock } from '../../../../components/Motion';

interface AboutUsTeamProps {
  team: TypeAboutUsTeam;
}

const AboutUsTeam = ({ team }: AboutUsTeamProps) => {
  return (
    <SectionContainer>
      <Box>
        <VerticalBox>
          <TitleWrapper>
            <Title
              fontFamily={FONTS.TITLE}
              size={36}
              lineHeight={54}
              color={COLORS.SECTION_TITLE}
              title={team.Title}
            />
          </TitleWrapper>
          <AboutUsTeamContainer>
            {team.Team.map(item => (
              <AboutUsTeamItem key={item.id} name={item.Name} />
            ))}
          </AboutUsTeamContainer>
        </VerticalBox>
      </Box>
    </SectionContainer>
  );
};
const AboutUsTeamContainer = styled(MotionYOffsetBlock)`
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
  @media screen and (${device.xs}){
    gap: 10px;
  }
`;

const TitleWrapper = styled(MotionText)``;

export { AboutUsTeam };
